import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyCO3ARtVvxRa9BoWyDqhQOWS3cZeAnyBGQ',
    authDomain: 'leo-colombo-monarch-website.firebaseapp.com',
    projectId: 'leo-colombo-monarch-website',
    storageBucket: 'leo-colombo-monarch-website.appspot.com',
    messagingSenderId: '184918784536',
    appId: '1:184918784536:web:feced029770252ea28a16d',
    measurementId: 'G-5M1H4NYMHR'
};

const fb = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);

export default fb;